import { useEffect, useState } from "react";
import { DownloadSimple } from "@phosphor-icons/react";

export default function InstallPWA() {
  const [prompt, setPrompt] = useState(null);
  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", () => setPrompt(null));
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);
  if (!prompt) return null;
  const install = async () => { prompt.prompt(); await prompt.userChoice; setPrompt(null); };
  return (
    <button data-testid="install-pwa-btn" onClick={install}
      className="hidden items-center gap-1.5 rounded-full bg-[#2D6A4F] px-3 py-2 text-xs font-bold text-white transition-transform hover:scale-105 sm:flex">
      <DownloadSimple size={15} weight="bold" /> Install app
    </button>
  );
}
